import { Color } from './color.constants';
export class StatusColor {
    public static readonly Approved = Color.Green;
    public static readonly ACTIVE = Color.Green;
    public static readonly Posted = Color.Green;
    public static readonly Purchased = Color.Green;
    public static readonly Processed = Color.Green;
    public static readonly Paid = Color.Green;
    public static readonly VERIFIED = Color.Green;
    public static readonly UNFUNDED = Color.Green;
    public static readonly ELIGIBLE = Color.Green;
    public static readonly ENROLLED = Color.Green;

    public static readonly SENT = Color.Indigo;
    public static readonly EarlyPaid = Color.Indigo;
    public static readonly EARLYPAID = Color.Indigo;
    public static readonly EARLY_PAID = Color.Indigo;
    public static readonly FUNDED = Color.Indigo;
    public static readonly PAID = Color.Indigo;
    public static readonly EARLY_PAID_CLOSED = Color.Indigo;
    public static readonly PAY_LATER = Color.Indigo;

    public static readonly HasExisting = Color.Yellow;
    /** Factoring's version of  Ineligible */
    public static readonly Ineligible = Color.Yellow;
    public static readonly InProgress = Color.Yellow;
    public static readonly Pending = Color.Yellow;
    public static readonly PendingApproval = Color.Yellow;
    public static readonly Processing = Color.Yellow;
    public static readonly PROCESSING = Color.Yellow;
    public static readonly Received = Color.Yellow;
    public static readonly Submitted = Color.Yellow;
    public static readonly UnderReview = Color.Yellow;
    public static readonly IN_REVIEW = Color.Yellow;
    public static readonly PENDING = Color.Yellow;
    public static readonly UNKNOWN_STATUS = Color.Yellow;
    public static readonly NOT_ENROLLED = Color.Yellow;

    public static readonly Denied = Color.Red;
    public static readonly Rejected = Color.Red;
    public static readonly REJECTED = Color.Red;
    public static readonly WILL_NOT_FUND = Color.Red;
    /** Financing's version of  Ineligible */
    public static readonly INELIGIBLE = Color.Red;
    public static readonly CANCELLED = Color.Red;

    public static readonly Disabled = Color.Gray;

    public static readonly ADJUSTMENT = Color.GraphicGray;
    public static readonly CREDIT_MEMO = Color.Slate;
    public static readonly CLOSED = Color.GraphicGray;
    public static readonly INACTIVE = Color.GraphicGray;
    public static readonly UNREGISTERED = Color.GraphicGray;
    public static readonly SCHEDULED = Color.GraphicGray;
    public static readonly IN_TRANSFER = Color.GraphicGray;
    public static readonly STAGED = Color.GraphicGray;
    public static readonly REVOKED = Color.Slate;
}
